// If the course slug is not in this list, then the user will be redirected to the general trial course page
export const PERSONALIZED_COURSES: string[] = [
  'coding',
  'competition',
  'algorithms',
  'robotics',
  'hpe-hackathon-micro-course',
  'hpe-codewars-micro-course',
  'coding-project-trial-iit-guwahati-alcheringa-2023',
  'coding-project-trial-iit-guwahati-alcheringa-dsalgo-2023',
  'coding-project-trial-iit-bombay-mood-indigo-2023',
  'robotics',
  'hpe-code-battle-mentorship',
  'hpe-hackathon-mentorship',
  'hpe-codewars-2024-practice',
  'hackyoung-olympiad-2024',
  'codegenius-hackathon',
  'tls-trial-course',
  'math-trial-class',
  'app-development-trial-class',
  'data-science-trial-class',
  'roblox-trial-class',
  'ap-computer-science-a-trial-class',
  'scratch-programming-trial-class',
  'python-for-kids-trial-class',
  'web-development-trial-class',
  'game-development-trial-class',
  'public-speaking-trial-class',
  'creative-writing-storytelling-trial-class',
  // 'ai-trial-class',
]

// Mapping of old trial course queries to their corresponding active trial course queries to which the user has been redirected
export const courseRedirect: Record<string, string> = {
  'coding-project-trial-iit-guwahati-alcheringa-2023': 'coding',
  'coding-project-trial-iit-guwahati-alcheringa-dsalgo-2023': 'algorithms',
  'coding-project-trial-iit-bombay-mood-indigo-2023': 'coding',
  robotics: 'coding',
  'hpe-hackathon-micro-course': 'coding',
  'hpe-codewars-micro-course': 'coding',
  'tls-trial-course': 'coding',
}

// Removed CODING_PROJECT_COURSES as it's no longer used

export const MATH_TRIAL_CLASS: string[] = ['math-trial-class']

export const ela_TRIAL_CLASS: string[] = [
  'public-speaking-trial-class',
  'creative-writing-storytelling-trial-class',
]

// Maping competition slug to course slug
export const competitionCourseMapping = {
  'ioi-algorithms-preparation-guide': 'coding',
  'hpe-codewars-2024-code-battle': 'hpe-code-battle-mentorship',
  'hpe-codewars-2024-hackathon': 'hpe-hackathon-mentorship',
  'hpe-codewars-practice-arena': 'hpe-codewars-2024-practice',
  'hackyoung-olympiad-2024': 'hackyoung-olympiad-2024',
  'codegenius-hackathon': 'codegenius-hackathon',
}

// Update the logic to determine trial class subject name
export const getTrialSubject = (courseSlug: string): string => {
  if (MATH_TRIAL_CLASS.includes(courseSlug)) {
    return 'Math'
  }
  if (ela_TRIAL_CLASS.includes(courseSlug)) {
    return 'Public Speaking & Communication'
  }
  return 'Coding'
}

// Grades that can't book a Math trial from the website booking page
// (`/trial-class/booking/`). Only the website is blocked - the team can still
// book these from the dashboard, the AI agent or a callback.
export const MATH_TRIAL_BOOKING_DISABLED_GRADES: string[] = [
  'Grade 11',
  'Grade 12',
]

export const isWebsiteTrialBookingDisabled = (
  trialSubject: string,
  grade?: string
): boolean =>
  trialSubject === 'Math' &&
  !!grade &&
  MATH_TRIAL_BOOKING_DISABLED_GRADES.includes(grade)

export const getCourseNameFromAPI = (courseName: string) => {
  if (courseName === 'Math') {
    return 'Math'
  }
  if (courseName === 'ELA') {
    return 'Public Speaking & Communication'
  }
  return 'Coding'
}

// Subject for mid-sentence trial copy, e.g. "Join my AI & coding class".
// Call it inline inside <Trans> so the catalog placeholder stays {0}.
export const getTrialSubjectForSentence = (courseName: string) => {
  const subject = getCourseNameFromAPI(courseName)
  return subject === 'Coding' ? 'AI & coding' : subject.toLowerCase()
}
